module.exports = __webpack_public_path__ + "img/img16.2a95e5e2.svg";